import { forwardRef, type AnchorHTMLAttributes } from "react";

import { createLink, type LinkComponent } from "@tanstack/react-router";

// Sanctioned router-link adapter (UI-LAW §2.10 / §4). Feature components must
// not import the TanStack Router `Link` directly: routed links have to carry
// the same appearance as the `Link` typography primitive. This wraps the router
// link behaviour around an anchor styled with `marker-link`, keeping navigation
// semantics identical and typography sanctioned. Minimal by design — no extra
// props, no defaults beyond the appearance.
const RouterLinkAnchor = forwardRef<
  HTMLAnchorElement,
  AnchorHTMLAttributes<HTMLAnchorElement>
>(function RouterLinkAnchor({ className, ...props }, ref) {
  const anchorClasses = className ? `marker-link ${className}` : "marker-link";
  return <a className={anchorClasses} ref={ref} {...props} />;
});

export const RouterLink: LinkComponent<typeof RouterLinkAnchor> =
  createLink(RouterLinkAnchor);
